import React from 'react';
import Image from 'next/image';

import { LinkProps } from 'Elements/Link';

import {
    Container,
    Tag,
    ImageWrapper,
    Inner,
    StyledLink,
    Heading,
    Description
} from './SearchResult.styled';

export interface Props {
    heading: string;
    description?: string | React.ReactNode;
    tag?: string;
    link: LinkProps;
    image?: {
        src: string;
        alt?: string;
    };
}

const SearchResult: React.FC<Props> = props => {
    const { heading, description, tag, link, image } = props;

    return (
        <Container>
            {tag && <Tag>{tag}</Tag>}
            {image && (
                <ImageWrapper>
                    <Image
                        src={image.src}
                        alt={image.alt ? image.alt : ''}
                        fill
                        style={{ objectFit: 'cover', backgroundPosition: 'center' }}
                    />
                </ImageWrapper>
            )}
            <Inner>
                <StyledLink {...link} ariaLabel={`View ${heading}`}>
                    <Heading>{heading}</Heading>
                </StyledLink>
                {typeof description === 'string' ? (
                    <Description>{description}</Description>
                ) : (
                    description
                )}
            </Inner>
        </Container>
    );
};

export default SearchResult;
